import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect } from "react";
import axios from "axios";
import { cookies } from "@catchoftheday/utilities";
import { AUTH_TOKEN_EXPIRY_COOKIE_NAME, REFRESH_TOKEN_ENDPOINT } from "../../consts";
export var useRefreshAccessToken = function useRefreshAccessToken() {
  useEffect(function () {
    var refreshAccessToken = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tokenExpiryEpoch, isTokenExpired;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                tokenExpiryEpoch = cookies.get(AUTH_TOKEN_EXPIRY_COOKIE_NAME); // If the token expiry cookie is not set, the user is not logged in.

                if (tokenExpiryEpoch) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                isTokenExpired = new Date(Number(tokenExpiryEpoch) * 1000) <= new Date();

                if (isTokenExpired) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _context.next = 9;
                return axios.get(REFRESH_TOKEN_ENDPOINT);

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function refreshAccessToken() {
        return _ref.apply(this, arguments);
      };
    }(); // 1st call


    refreshAccessToken(); // Perform token expiry check every 5 seconds

    setInterval(refreshAccessToken, 5000);
  }, []);
  return null;
};